import React from 'react';
import Image from 'next/image';
import styles from './styles';

const FeatureBlock = ({
  index,
  toggleItem,
  expandedItems,
  discussionTitle,
}) => {
  return (
    <>
      <div
        onClick={() => toggleItem(index)}
        className={
          'features-block-title' + (expandedItems[index] ? ' red-border' : '')
        }
      >
        <h3>{discussionTitle}</h3>
        <div
          className={`features-block-icon ${
            expandedItems[index] ? 'features-block-icon-active' : ''
          }`}
        >
          <Image
            draggable={false}
            src="/icons/fluent_ios-arrow.png"
            alt="icon-search"
            width={18}
            height={18}
            loading="lazy"
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FeatureBlock;
